<template>
  <fragment>
    <hero-header :page-name="job.subtitle ? job.subtitle : ''" :hero-title="job.title"/>
    <v-container class="my-5">
      <v-row class="my-5">
        <!-- ÁLLÁSHIRDETÉS SZÖVEGE START -->
        <v-col cols="12" md="8">
          <div v-html="job.details"></div>
        </v-col>
        <!-- SIDEBAR START -->
        <v-col cols="12" md="4">
          <v-row>
            <!-- <v-col cols="12" sm="6" md="12">
              <v-card class="mb-10">
                <v-card-title class="primary">
                  <span class="white&#45;&#45;text">Az állásról</span>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <template v-for="(item, index) in job.summary">
                      <v-list-item :key="index" class="px-0">
                        <v-list-item-avatar class="mr-2">
                          <v-icon size="22">
                            mdi-arrow-right-circle
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ item }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col> -->
            <v-col cols="12" sm="6" md="12">
              <v-card class="mb-10">
                <v-card-title class="primary">
                  <span class="white--text">Jelentkezés módja</span>
                </v-card-title>
                <v-card-text class="pa-5">
                  <p>
                    Kattints a <b>JELENTKEZEM</b> gombra a hirdetés alatt vagy küldd el az önéletrajzod az <a href="mailto:allas@tmx.hu">allas@tmx.hu</a> email címre.
                    Ha a tapasztalataid alapján úgy látjuk, hogy Te vagy mi emberünk, felvesszük Veled a kapcsolatot.
                  </p>
                  <v-list>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3">
                        <v-icon size="22">
                          mdi-email
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <a href="mailto:allas@tmx.hu">allas@tmx.hu</a>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="12" v-show="$vuetify.breakpoint.mdAndUp">
              <v-card>
                <v-card-title class="primary">
                  <span class="white--text">Rólunk röviden</span>
                </v-card-title>
                <v-card-text class="pa-5">
                  <p class="font-weight-bold mb-0 body-1">TMX Mobile Solution Szerviz Kft.</p>
                  <p>Mobiltelefonok, tabletek javítása</p>
                  <v-list>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3">
                        <v-icon size="22">
                          mdi-account-group
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          350 alkalmazott
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3">
                        <v-icon size="22">
                          mdi-city
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          Alapítva: 1997
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3">
                        <v-icon size="22">
                          mdi-map-marker
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          2040 Budaörs, Kinizsi utca 2/b
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="primary darken-1">
      <v-container class="my-10">
        <v-row align="center">
          <v-col cols="12" sm="8" :class="$vuetify.breakpoint.smAndDown ? 'mb-6' : ''">
            <p :class="$vuetify.breakpoint.smAndDown ? `display-1 font-weight-regular white--text` : `display-2 font-weight-regular white--text`">
              El tudod képzelni magad nálunk?
            </p>
            <p :class="$vuetify.breakpoint.smAndDown ? `display-1 font-weight-regular white--text` : `display-1 font-weight-regular white--text`">
              Küldd el az önéletrajzod!
            </p>
            <p class="body-1 white--text mt-8">
              Ha a tapasztalataid alapján úgy látjuk, hogy Te vagy mi emberünk, felvesszük Veled a kapcsolatot.
            </p>
          </v-col>
          <v-col cols="12" sm="4" style="text-align: center;">
            <v-btn class="white" x-large rounded @click="showFormClick" min-width="148">
              JELENTKEZEM
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!--v-container>
      <v-row>
        <v-col cols="12">
          Küldd el az önéletrajzod!
        </v-col>
        <fancy-headline title="Küldd el az önéletrajzod!" name="El tudod képzelni magad nálunk?" />
        <v-col cols="12" class="text-center font-weight-bold py-0">
          Ha a tapasztalataid alapján úgy látjuk, hogy Te vagy mi emberünk, felvesszük Veled a kapcsolatot.
        </v-col>
        <v-col cols="12" class="py-10">
          <v-row justify="center">
            <v-btn color="primary"
                   x-large
                   rounded
                   @click="showFormClick">
              JELENTKEZEM
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container-->
    <!-- CONTACT FORM SECTION START -->
    <v-container class="my-5" id="jobForm">
      <v-slide-y-transition>
        <v-row v-show="showForm">
          <!--<fancy-headline title="Küldd el önéletrajzod és visszahívunk" name="Jelentkezés" />-->
          <contact-form-job-application :props-division-id="job.divisionId"
                                        :props-job-id="job.jobId"/>
        </v-row>
      </v-slide-y-transition>
    </v-container>
    <!-- CONTACT FORM SECTION END -->
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
// import listWithTitle from '../components/listWithTitle.vue';
import fancyHeadline from '../components/fancyHeadline.vue';
import contactFormJobApplication from '../components/contactFormJobApplication.vue';
import { JOBS_GET_JOB_BY_ID } from '../store/getters.type';
import { JOBS_SET_SELECTFIELDOPTIONS } from '../store/mutations.type';

export default {
  name: 'activeJob',
  async beforeMount() {
    if (this.$route.params.jobID) {
      this.job = await this.getJobDetails();
    } else {
      //
    }
  },
  components: {
    heroHeader, fancyHeadline, contactFormJobApplication,
  },
  data() {
    return {
      job: {},
      showForm: false,
    };
  },
  methods: {
    async getJobDetails() {
      if (this.$store.state.jobsStore.jobsForSelectFieldOptions.length === 1) {
        this.$store.commit(JOBS_SET_SELECTFIELDOPTIONS);
      }
      const response = await this.$store.dispatch(JOBS_GET_JOB_BY_ID, this.$route.params.jobID);
      return response;
      // this.contactForm.division = this.job.divisionId;
      // this.contactForm.position = this.job.title;
    },
    showFormClick() {
      this.showForm = true;
      setTimeout(this.scrollToForm, 100);
      /* window.scrollTo({
        top: this.$refs.jobForm.offsetTop,
        left: 0,
        behavior: 'smooth',
      }); */
    },
    scrollToForm() {
      const element = document.getElementById('jobForm');
      element.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>

</style>
